<template>
  <Teleport to="body">
    <Transition name="toast">
      <div
        v-if="show"
        class="fixed bottom-4 right-4 z-[60] max-w-sm"
      >
        <div
          :class="[
            'flex items-center gap-3 pl-3 pr-2 py-2.5 rounded-[var(--radius-md)] border shadow-lg',
            toneClasses,
          ]"
        >
          <component :is="icon" :size="16" :stroke-width="2" />
          <span class="text-[13px] flex-1 min-w-0">{{ message }}</span>
          <button
            type="button"
            @click="$emit('close')"
            class="shrink-0 p-1 rounded hover:bg-white/10 opacity-70 hover:opacity-100"
            aria-label="Dismiss"
          >
            <X :size="14" />
          </button>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue';
import { CheckCircle2, AlertCircle, AlertTriangle, Info, X } from 'lucide-vue-next';

const props = defineProps({
  show:    { type: Boolean, required: true },
  message: { type: String, default: '' },
  type:    { type: String, default: 'success' }, // success | error | warning | info
});
defineEmits(['close']);

const icon = computed(() => ({
  success: CheckCircle2,
  error:   AlertCircle,
  warning: AlertTriangle,
  info:    Info,
}[props.type] || CheckCircle2));

const toneClasses = computed(() => ({
  success: 'bg-bg-1 text-ok border-[rgba(74,222,128,0.45)]',
  error:   'bg-bg-1 text-err border-[rgba(240,82,82,0.45)]',
  warning: 'bg-bg-1 text-warn border-[rgba(245,165,36,0.45)]',
  info:    'bg-bg-1 text-text-2 border-line-2',
}[props.type] || 'bg-bg-1 text-text-2 border-line-2'));
</script>

<style scoped>
.toast-enter-active, .toast-leave-active { transition: transform var(--dur) var(--ease), opacity var(--dur) var(--ease); }
.toast-enter-from, .toast-leave-to { opacity: 0; transform: translateY(8px); }
</style>
